import { Action } from '@ngrx/store';
import { UserNotificationChannel } from '@model';

export enum UserNotificationSettingActionTypes {
  UserNotificationChannelsLoadData = '[UserNotificationChannels] Load data',
  UserNotificationChannelsLoadDataSuccess = '[UserNotificationChannels] Load success',
  UserNotificationChannelsLoadDataFail = '[UserNotificationChannels] Load fail',
  UserNotificationChannelUpdateItems = '[UserNotificationChannels] Update',
  UserNotificationChannelUpdateItemsSuccess = '[UserNotificationChannels] Update success',
  UserNotificationChannelUpdateItemsFail = '[UserNotificationChannels] Update fail',
  UserNotificationChannelUpdateItem = '[UserNotificationChannel] Update',
  UserNotificationChannelUpdateItemSuccess = '[UserNotificationChannel] Update success',
  UserNotificationChannelUpdateItemFail = '[UserNotificationChannel] Update fail'
}

export class UserNotificationChannelsLoad implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelsLoadData;
  constructor() {}
}
export class UserNotificationChannelsLoadSuccess implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelsLoadDataSuccess;
  constructor(public payload: UserNotificationChannel[]) {}
}
export class UserNotificationChannelsLoadFail implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelsLoadDataFail;
  constructor(public payload: any) {}
}
export class UserNotificationChannelsUpdate implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelUpdateItems;
  constructor(public payload: UserNotificationChannel[]) {}
}
export class UserNotificationChannelsUpdateSuccess implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelUpdateItemsSuccess;
  constructor(public payload: UserNotificationChannel[]) {}
}
export class UserNotificationChannelsUpdateFail implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelUpdateItemsFail;
  constructor(public payload: any) {}
}

export class UserNotificationChannelUpdate implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelUpdateItem;
  constructor(public payload: UserNotificationChannel
    ) {}
}
export class UserNotificationChannelUpdateSuccess implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelUpdateItemSuccess;
  constructor(public payload: UserNotificationChannel) {}
}
export class UserNotificationChannelUpdateFail implements Action {
  readonly type = UserNotificationSettingActionTypes.UserNotificationChannelUpdateItemFail;
  constructor(public payload: any) {}
}

export type UserNotificationSettingAction =
  | UserNotificationChannelsLoad
  | UserNotificationChannelsLoadSuccess
  | UserNotificationChannelsLoadFail
  | UserNotificationChannelsUpdate
  | UserNotificationChannelsUpdateSuccess
  | UserNotificationChannelsUpdateFail
  | UserNotificationChannelUpdate
  | UserNotificationChannelUpdateSuccess
  | UserNotificationChannelUpdateFail;
